var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.click == null)?_c('router-link',{class:_vm.className,attrs:{"to":_vm.to}},[_vm._t("default")],2):_c('a',{class:_vm.className,attrs:{"tabindex":""},on:{"click":_vm.click}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }